export default __webpack_public_path__ + "static/media/162521687_108633284644527_3349228963391439343_n.b734d0f5.jpg";